// ゼンリン Maps API の word 長検証（2〜100文字）。Geospace 経路では使わない。
// https://developers.zmaps-api.com/v20/reference/webAPI/address.html

import {
  ZENRIN_WORD_MATCH_TYPE,
  type ZenrinWordMatchType,
} from "@/features/map/utils/zenrinWordMatchType";

/** word_match_type 1 or 3 では最小2文字 */
export const ZENRIN_WORD_MIN_LENGTH = 2;

/** 先頭100文字まで検索 */
export const ZENRIN_WORD_MAX_LENGTH = 100;

export const ZENRIN_WORD_TOO_SHORT_MESSAGE =
  "検索には2文字以上入力してください。";

export const ZENRIN_WORD_TOO_LONG_MESSAGE =
  "検索語は100文字以内で入力してください。";

export type ZenrinWordValidationResult =
  | { ok: true }
  | { ok: false; message: string };

/** API 仕様どおりスペース除去後の文字列に正規化する */
export const normalizeZenrinWord = (input: string): string =>
  input.trim().replace(/\s/g, "");

const zenrinWordLength = (normalized: string): number => [...normalized].length;

/** word_match_type 1 or 3（未指定含む）向けの長さ検証 */
export const validateZenrinWordQuery = (
  input: string
): ZenrinWordValidationResult => {
  const normalized = normalizeZenrinWord(input);
  const length = zenrinWordLength(normalized);

  if (length < ZENRIN_WORD_MIN_LENGTH) {
    return { ok: false, message: ZENRIN_WORD_TOO_SHORT_MESSAGE };
  }

  if (length > ZENRIN_WORD_MAX_LENGTH) {
    return { ok: false, message: ZENRIN_WORD_TOO_LONG_MESSAGE };
  }

  return { ok: true };
};

/** 前方一致(PREFIX)のみ長さ検証の対象外 */
export const shouldValidateZenrinWord = (
  wordMatchType?: ZenrinWordMatchType
): boolean => wordMatchType !== ZENRIN_WORD_MATCH_TYPE.PREFIX;
